import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { initOptionsSelectors } from '@store/app/init-options/init-options.selectors';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[visibleOnUiVersion]',
})
export class VisibleOnUiVersionDirective implements OnDestroy {
  private subscription = new Subscription();
  private uiVersion$ = this.store$.select(initOptionsSelectors.uiVersion);

  constructor(
    // tslint:disable-next-line:no-any
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    protected store$: Store
  ) {}

  @Input() set visibleOnUiVersion(uiVersions: string[]) {
    this.subscription.unsubscribe();

    this.subscription = this.uiVersion$.subscribe((uiVersion) => {
      if (uiVersions.includes(uiVersion)) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainerRef.clear();
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
